const BUYER_FIELD_KEY = /^buyers\.(\d+)\.(.+)$/;

/** Splits a form field key like `buyers.2.person.email` into the row index and the path within the row. */
export function parseBuyerFieldKey(key: string): {index: number; path: string} | null {
  const match = BUYER_FIELD_KEY.exec(key);
  return match ? {index: Number(match[1]), path: match[2] ?? ''} : null;
}
